"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDateOfBirth = exports.getDateOfBirthFromSsn = void 0;
var getDateOfBirthFromSsn = function (value) {
    // D-number support
    var dayOfBirth = Number(value.slice(0, 2));
    if (dayOfBirth > 31)
        dayOfBirth -= 40;
    // H-number support
    var monthOfBirth = Number(value.slice(2, 4));
    if (monthOfBirth > 40)
        monthOfBirth -= 40;
    var yearOfBirth = Number(value.slice(4, 6));
    yearOfBirth += yearOfBirth > 50 ? 1900 : 2000;
    return new Date(yearOfBirth + "-" + monthOfBirth.toString().padStart(2, '0') + "-" + dayOfBirth.toString().padStart(2, '0') + "T00:00:00.000Z");
};
exports.getDateOfBirthFromSsn = getDateOfBirthFromSsn;
var validateDateOfBirth = function (dateOfBirth) { return dateOfBirth instanceof Date && !isNaN(dateOfBirth.getTime()); };
exports.validateDateOfBirth = validateDateOfBirth;
//# sourceMappingURL=validateDateOfBirth.js.map